import { type ReactNode } from 'react'
import { type LucideIcon } from 'lucide-react'
import {
  Tooltip, TooltipContent, TooltipTrigger,
} from '@/components/shadcn/tooltip'

/** A cell in a module card's info grid: icon + label above, value below (single line,
 *  truncated on overflow). Optionally a tooltip showing the full value.
 *  Shared by `ActionCard` and `ShopModuleCard`. */
export function InfoCell({
  icon: Icon,
  label,
  value,
  tooltip,
}: {
  icon: LucideIcon
  label: string
  value: string
  tooltip?: ReactNode
}) {
  const valueNode = <span className="block truncate font-medium">{value}</span>
  return (
    <div className="flex min-w-0 items-center gap-1.5">
      <Icon className="size-3.5 shrink-0 text-muted-foreground" />
      <div className="flex min-w-0 flex-col leading-tight">
        <span className="text-[10px] text-muted-foreground">{label}</span>
        {tooltip ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="block cursor-default truncate font-medium">{value}</span>
            </TooltipTrigger>
            <TooltipContent>{tooltip}</TooltipContent>
          </Tooltip>
        ) : (
          valueNode
        )}
      </div>
    </div>
  )
}
